import React from 'react'
import {LABORATORY_COMMENT_DESCRIPTION, URL_CY_PRACTICE} from '../../../constants/CyHomepage'
import {LaboratoryItemCard} from "../components/LaboratoryItemCard";
import {diffEndJump} from "../../../utils/tools";

const LaboratoryCommentPanel: React.FC<{
    isInScreen: boolean
}> = ({
          isInScreen = false
      }) => {

    function clickStat(category, page) {
        // 统计卡片点击流量
        if (window) {
            // 用 stat-portrait
            // @ts-ignore
            window.xqui.useStat({
                action: 'click',
                category: category,
                bizType: 5,
                page: page
            })
        }
        diffEndJump({
            href: URL_CY_PRACTICE,
            isOpenNewWindow: true
        })
    }
    return (
        <div className='laboratory-comment-panel-children'>
            <div className='description-cards'>
                {
                    LABORATORY_COMMENT_DESCRIPTION.map((item, index) => (
                        <div className={`description-card ${isInScreen ? 'animated fadeInUp' : ''}`}
                             style={{ animationDuration: `${index > 1 ? `${1.5 + index * 0.3}s` : '1s'}` }}
                             onClick={() => clickStat(item.category, item.page)}>

                            <LaboratoryItemCard
                                key={index}
                                title={item.title}
                                imgUrl={item.imgUrl}
                            />
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default LaboratoryCommentPanel
